import React, { Component } from "react";
import { connect } from "react-redux";
import { Form, Icon, Input, Button } from "antd";
import { NotificacioExit, NotificacioError, NotificacioWarning } from './Notification';
import { fetchLogin, logout } from "../actions/consultesServidor";
import PropTypes from "prop-types";
import {
  MISSATGE_CAMP_OBLIGATORI,
  RANG_MIN_MAX_CARACTERS_CONTRASENYA,
  MISSATGE_CONTRASENYA_LONGITUD,
  MISSATGE_USUARI_NO_ACTIU,
  MISSATGE_USUARI_NO_AUTORITZACIO,
  MISSATGE_SESSIO_TANCAR,
  MISSATGE_NO_CONEXIO_SERVIDOR,
  MISSATGE_SESSIO_ESBORRAR_TITOL,
  MISSATGE_SESSIO_ESBORRAR_DESCRIPTION,
  MISSATGE_SESSIO_BLOQUEJADA,
  MISSATGE_ERROR_SERVIDOR
} from "../constantsFormularis";
import styles from "./LoginFormulari.module.css";
import {
  omplirUsuariAutenticat,
  errorConsultaServidor,
  esborrarValors
} from "../actions";
import configuracio from "../configuracioEntorns";
import { hasSessionInAnotherTab } from "../utils/sessionTab";
import {
  LOCAL_STORAGE_ACTIVE_SESSION_TAB,
  LOCAL_STORAGE_ACTIVE_SESSION_TAB_HEARTBEAT
} from "../constantsObservacions";

const urlBase = `${configuracio.ruta}`;
const FormItem = Form.Item;

const iconaInputUsuari = (
  <Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />
);
const inputUsuari = (
  <Input
    size="large"
    prefix={iconaInputUsuari}
    autoComplete="username"
    placeholder="Nom d'usuari"
    aria-label="Nom d'usuari"
  />
);

const iconaInputContrasenya = (
  <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
);
const inputContrasenya = (
  <Input
    size="large"
    prefix={iconaInputContrasenya}
    type="password"
    autoComplete="current-password"
    placeholder="Contrasenya"
    aria-label="Contrasenya"
  />
);

class LoginFormulari extends Component {
  state = {
    peticioLoginEnCurs: false,
    botoEsborrarSessioOcult: false
  };

  esborrarSessioActiva = () => {
    const { esborrarValors } = this.props;

    localStorage.removeItem(LOCAL_STORAGE_ACTIVE_SESSION_TAB);
    localStorage.removeItem(LOCAL_STORAGE_ACTIVE_SESSION_TAB_HEARTBEAT);

    esborrarValors();
    logout();

    this.setState({ botoEsborrarSessioOcult: true });

    NotificacioExit(
      MISSATGE_SESSIO_ESBORRAR_TITOL,
      MISSATGE_SESSIO_ESBORRAR_DESCRIPTION
    )
  };

  handleSubmit = e => {
    const { form, omplirUsuariAutenticat, history } = this.props;

    e.preventDefault();

    if (hasSessionInAnotherTab()) {
      NotificacioWarning(MISSATGE_SESSIO_BLOQUEJADA, MISSATGE_SESSIO_TANCAR);
      return;
    }

    form.validateFields((err, values) => {
      if (!err) {
        const { usuari, contrasenya } = values;
        this.setState({ peticioLoginEnCurs: true });
        fetchLogin(usuari, contrasenya).then(
          usuari => {
            this.setState({ peticioLoginEnCurs: false });
            if (!usuari.message && !usuari.actiu) {
              return this.props.errorConsultaServidor(
                MISSATGE_USUARI_NO_AUTORITZACIO,
                MISSATGE_USUARI_NO_ACTIU
              );
            }
            if (usuari.message && usuari.titol) {
              return this.props.errorConsultaServidor(
                usuari.titol,
                usuari.message
              );
            }
            omplirUsuariAutenticat(usuari);
            history.push(`${urlBase}/`);
          },
          error => {
            NotificacioError(MISSATGE_ERROR_SERVIDOR, MISSATGE_NO_CONEXIO_SERVIDOR);
            this.setState({ peticioLoginEnCurs: false });
          }
        );
      }
    });
  };
  render() {
    const { getFieldDecorator } = this.props.form;
    const { peticioLoginEnCurs, botoEsborrarSessioOcult } = this.state;
    const sessioBloquejada = hasSessionInAnotherTab();
    const mostrarBotoEsborrarSessions =
      sessioBloquejada && !botoEsborrarSessioOcult;

    return (
      <Form onSubmit={this.handleSubmit} className={styles.LoginFormulari}>
        <FormItem>
          {getFieldDecorator("usuari", {
            rules: [{ required: true, message: MISSATGE_CAMP_OBLIGATORI }]
          })(inputUsuari)}
        </FormItem>
        <FormItem>
          {getFieldDecorator("contrasenya", {
            rules: [
              { required: true, message: MISSATGE_CAMP_OBLIGATORI },
              {
                min: RANG_MIN_MAX_CARACTERS_CONTRASENYA[0],
                max: RANG_MIN_MAX_CARACTERS_CONTRASENYA[1],
                message: MISSATGE_CONTRASENYA_LONGITUD
              }
            ]
          })(inputContrasenya)}
        </FormItem>
        <Button
          size="large"
          type="primary"
          htmlType="submit"
          className={styles.LoginFormulariButton}
          loading={peticioLoginEnCurs}
          disabled={peticioLoginEnCurs}
        >
          Iniciar sessió
        </Button>

        {mostrarBotoEsborrarSessions && (
          <Button
            size="large"
            type="primary"
            onClick={this.esborrarSessioActiva}
            className={styles.LoginFormulariButton}
          >
            Esborrar sessions actives
          </Button>
        )}
      </Form>
    );
  }
}

LoginFormulari.propTypes = {
  form: PropTypes.shape({
    validateFields: PropTypes.func.isRequired,
    getFieldDecorator: PropTypes.func.isRequired
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  omplirUsuariAutenticat: PropTypes.func,
  errorConsultaServidor: PropTypes.func,
  esborrarValors: PropTypes.func
};

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {
  omplirUsuariAutenticat,
  errorConsultaServidor,
  esborrarValors
};

const WrappedLoginFormulari = Form.create()(
  connect(mapStateToProps, mapDispatchToProps)(LoginFormulari)
);
export default WrappedLoginFormulari;
